<template>
<v-list-tile
  @click='$emit("selected", person)' >
  <slot name='tile-before-content' >
  <v-list-tile-avatar >
    <v-avatar >
      <img v-if='person.profile_picture' :src='person.profile_picture' />
      <v-icon v-else >
        account_circle
      </v-icon>
    </v-avatar>
  </v-list-tile-avatar>
  </slot>
  <v-list-tile-content >
    <slot name='tile-title' >
      <v-list-tile-title>
        {{ person.title }}
        {{ person.initials }}
        {{ person.first_name }}
        {{ person.last_name }}
        <span v-if='person.nickname' >({{person.nickname}})</span>
      </v-list-tile-title>
    </slot>
    <slot name='tile-sub-title' >
      <v-list-tile-sub-title v-if='!compact'  >
        <v-icon>phone</v-icon> {{ person.cell_phone}}
      </v-list-tile-sub-title>
    </slot>
    <slot name='tile-extra' >
      <v-list-tile-sub-title v-if='!compact'  >
        <v-icon>email</v-icon> {{ person.email}}
      </v-list-tile-sub-title>
    </slot>
  </v-list-tile-content>
  <slot name='tile-after-content' >
    <v-list-tile-action v-if='withEdit' >
      <v-btn @click.stop='$emit("edit", person)' icon ><v-icon>edit</v-icon></v-btn>
    </v-list-tile-action>
  </slot>
</v-list-tile>
</template>

<script>
export default {
  name: 'PersonListItem',
  props: {
    person: { type: Object },
    compact: { type: Boolean, default: false },
    withEdit: { type: Boolean, default: false }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// PersonListItem.vue?1be6445d